import { Link } from 'react-router-dom'
import { BRAND_NAME } from '../config/brand'

export const RISK_DISCLAIMER = 'Signals are a published record, not financial advice.'

/** Footer for signed-in pages: year, legal links and the one-line risk note. */
const AppFooter = () => (
  <footer
    className="mt-12 flex flex-col gap-2 border-t border-gray-200 pt-4 text-xs text-gray-500 dark:border-terminal-border dark:text-gray-500 sm:flex-row sm:items-center sm:justify-between"
    data-testid="app-footer"
  >
    <span>
      © {new Date().getFullYear()} {BRAND_NAME}
    </span>
    <span className="flex flex-wrap items-center gap-x-3 gap-y-1">
      <span data-testid="risk-disclaimer">{RISK_DISCLAIMER}</span>
      <Link to="/terms#disclaimers" className="underline hover:text-gray-300">
        Risk disclosure
      </Link>
      <Link to="/terms" className="hover:text-gray-300">
        Terms
      </Link>
      <Link to="/privacy" className="hover:text-gray-300">
        Privacy
      </Link>
    </span>
  </footer>
)

export default AppFooter
